import React, { useState } from "react";
import CandidatTable from "./CandidatTable/index";
import { PageLayout } from "../../../components/UI";

const Candidats = () => {
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(15);
  const [offset, setOffset] = useState(1);

  const props = { setOffset, setLimit, count, setCount };

  return (
    <PageLayout sx={{ px: { xs: 1, sm: 1.5, md: 2 } }}>
      <CandidatTable {...props} />
    </PageLayout>
  );
};

export default Candidats;
